export default __webpack_public_path__ + "static/ReferralPage--hero-9767db6fc58fa2ed020f2ef0b24289e8.webm";